import { Stroke, Fill, Icon, Text, Circle, Style } from "ol/style.js";
import Point from "ol/geom/Point";
// import Polygon from 'ol/geom/Polygon';
// import MultiPolygon from 'ol/geom/MultiPolygon';
// import LineString from 'ol/geom/LineString';
// import MultiLineString from 'ol/geom/MultiLineString';

import { toParams } from "@/utils/index.js";
import store from "@/store";
import * as menu from "@/api/menu.js";

import { getCenter as getExtentCenter } from "ol/extent";

const srsname = "EPSG:4326";
const baseURL = process.env.VUE_APP_API_ENDPOINT;

let controllers = {};
function setUrl(id, extent) {
  let filter = store.getters.getFilterURL(id);

  let params = toParams({
    srsname: srsname,
    zoom: store.getters.getZoom,
    bbox: extent.join(","),
    task_id: store.getters.getTask.id,
    token: store.getters.getToken,
  });

  return `${baseURL}item/${id}/?${params}&filter=${filter}`;
}

function setReleaseUrl(id, item_id, extent) {
  let params = toParams({
    srsname: srsname,
    zoom: store.getters.getZoom,
    bbox: extent.join(","),
    token: store.getters.getToken,
  });
  return `${baseURL}release/${id}/${item_id}/?${params}`;
}

function itemUrlFunction(id, release_id) {
  if (release_id) {
    return function (extent) {
      return setReleaseUrl(release_id, id, extent);
    };
  } else {
    return function (extent) {
      return setUrl(id, extent);
    };
  }
}

function itemLoadUrlFunction(id, extent, release_id) {
  if (release_id) {
    return setReleaseUrl(release_id, id, extent);
  } else {
    return setUrl(id, extent);
  }
}

function extraItemUrlFunction(id, query) {
  /* 추가 features 불러오는 url */
  return function (extent) {
    let params = toParams({
      srsname: srsname,
      bbox: extent.join(","),
      token: store.getters.getToken,
    });
    params += "&" + toParams(query);
    return `${baseURL}item/${id}/?${params}`;
  };
}

function scaledFont(font, scale) {
  const fontSize = font.split("px")[0];
  return font.replace(fontSize, Number(fontSize) * scale);
}

export function setExtraLayer(payload) {
  var layer = {
    id: payload.id, // feature id
    queryId: payload.queryId, // api 요청시 사용하는 id (세부 항목 id-style부를때에도 사용)
    itemId: payload.itemId, // 요청하는 항목 id (activeLayer해제시 extraLayer도 함께 해제)
    url: extraItemUrlFunction(payload.queryId, payload.query),
    maxZoom: payload.maxZoom,
    query: payload.query,
    extraType: payload.type,
  };

  menu.getItemList(`id=${payload.queryId}`).then((res) => {
    layer.style = res.data[0].style;
    layer.maxZoom = res.data[0].max_zoom_level;
  });

  return layer;
}

export function setLayer(payload, isRelease = false) {
  let params = payload.default_param ? payload.default_param : {};

  const layer_id = payload.id;
  var layer = {
    id: payload.id,
    name: payload.name,
    sourceType: payload.source_type,
    maxZoom: payload.max_zoom_level,
    style: payload.style,
    zoom_range_1: payload.zoom_range_1,
    zoom_range_2: payload.zoom_range_2,
    zoom_range_3: payload.zoom_range_3,
    use_popup: payload.use_popup,
    popup_setting: payload.popup_setting,
    use_label: payload.use_label,
    label_setting: payload.label_setting,
    legend_key: payload.legend_key,
    visible: true,
    category: payload.category,
    source_date: payload.source_date,
    features: [],
    latestUrl: null,
    loaderfactory: function () {
      return (extent) => {
        extent = extent.map((val) => Number(val.toFixed(6)));

        // 앞선 요청 취소
        if (controllers[layer_id]) controllers[layer_id].abort();

        const controller = new AbortController();
        const signal = controller.signal;

        controllers[layer_id] = controller;
        const url = itemLoadUrlFunction(payload.id, extent, isRelease);
        layer.latestUrl = url;

        fetch(url, { signal })
          .then((r) => r.json())
          .then((data) => {
            // 최신 요청이 아닌경우 업데이트 하지 않음
            let isLatestUrl = layer.latestUrl == url;
            if (!isLatestUrl && layer.latestUrl) {
              return;
            } else {
              const source = this.$source;
              const features = source.getFormat().readFeatures(data, {
                dataProjection: "EPSG:4326",
                featureProjection: "EPSG:3857",
              });

              if (source && source.addFeatures && features && features.length) {
                this.$nextTick(() => {
                  source.addFeatures(features);
                });
              }
              controllers[layer_id] = null;
            }
          })
          .catch((e) => {
            if (e.name == "AbortError") return;
          });
      };
    },
  };

  // Loader
  layer.url = itemUrlFunction(payload.id, isRelease);

  // Optional
  layer.typename = params.TYPENAME ? params.TYPENAME : null;
  layer.model = params.model ? params.model : null;
  layer.buffer = params.buffer ? params.buffer : null;
  layer.queryId = params.queryId ? params.queryId : null; // extralayer 요청 시 필요
  layer.zoom_setting = params.zoom_setting ? params.zoom_setting : null;

  return layer;
}

function getLabelName(feature) {
  let name = "";
  if (feature.values_.edited_property && feature.values_.edited_property.name) {
    name = feature.values_.edited_property.name;
  } else {
    name = feature.values_.name;
  }
  return name;
}

function getTextByZoom(zoom, type, add = 0) {
  if (!CUSTOM_SIZE[type]) return null;
  let size = CUSTOM_SIZE[type][zoom];
  if (!size) return "10px Roboto";
  return `${size + add}px Roboto` || "";
}

function getScaleByZoom(zoom, type) {
  if (!CUSTOM_SIZE[type]) return null;
  let size = CUSTOM_SIZE[type][zoom];
  if (!size) return null;
  return size;
}

function linebreakText(text) {
  if (text && text.includes("\\")) {
    let temp = "";

    text.split("\\").forEach((t) => {
      temp += t + "\n";
    });

    return temp;
  }

  return text;
}

function setCustomText(text, key) {
  if (key == "단계" && text) {
    if (text == "미지정") {
      return "";
    } else {
      return `(${text.slice(0, 2)})`;
    }
  }

  return text;
}

function checkLandUsePlanHideLabel(feature) {
  let legend = "";
  if (
    feature.values_.edited_property &&
    feature.values_.edited_property.legend
  ) {
    legend = feature.values_.edited_property.legend;
  } else {
    legend = feature.values_.legend;
  }

  return store.getters.getLandUsePlanHideLabel.includes(legend);
}

// VL - Style Functions
export const styleCustomFunction = {
  // Style
  setFill(style) {
    if (!style || !style.fill) return null;

    return new Fill({ color: style.fill.color });
  },
  setStroke(style) {
    if (!style || !style.stroke) return null;

    let lineDash = null;

    if (style.stroke.type === "line-dotted-type1") {
      lineDash = [4];
      if (style.stroke.width) {
        lineDash = [Number(style.stroke.width) * 2];
      }
    } else if (style.stroke.type === "line-dotted-type2") {
      lineDash = [4, 4, 1, 4];
      if (style.stroke.width) {
        let width = Number(style.stroke.width);
        lineDash = [width * 2, width * 2, 1, width * 2];
      }
    }
    let color = [];
    try {
      style.stroke.color.forEach((val) => {
        color.push(Number(val));
      });
    } catch {
      color = null;
    }

    return new Stroke({
      color: color,
      width: Number(style.stroke.width),
      lineDash: lineDash,
    });
  },
  setPoint(style, zoom, type) {
    if (!style || !style.point) return null;
    let src = style.point.src;
    let scale = 1;

    if (!src) {
      // Circle
      return new Circle({
        fill: new Fill({
          color: style.point.fill,
        }),
        stroke: new Stroke({
          color: style.point.stroke,
        }),
        radius: style.point.radius * (zoom / 10),
      });
    } else {
      // Icon with image
      if (style.point.scale) {
        scale = getScaleByZoom(zoom, "IC_JC_STATION_ICON");
        if (!scale) return null;
      }
      if (src.includes("static/")) {
        if (type == "extra") {
          src =
            process.env.VUE_APP_API_ENDPOINT.replace("api/", "") +
            src.replace(".png", "_focus.png");
        } else {
          src = process.env.VUE_APP_API_ENDPOINT.replace("api/", "") + src;
        }
      }

      return new Icon({
        src: src,
        anchor: [0.5, 0.5],
        scale: scale,
      });
    }
  },
  setText(feature, zoom, style, isRoadRailBrt, label_setting = null) {
    if (!style) return null;
    const scale = 1;

    let text = "";
    let offsetY = 0;
    let font = "";
    let legend = "";
    let business_class = "";
    let stru = "";

    const item_id = feature.id_.split(".")[0];

    if (store.getters.getHideLabel[item_id]) {
      return null;
    } else if (
      item_id == "8ca73eb1-a282-42a8-8fcb-7569239562a6" &&
      checkLandUsePlanHideLabel(feature)
    ) {
      // 토지이용계획도 특정라벨 숨기기 기능
      return null;
    }
    const isLabelFeature = style.featuretype == "Label";

    if (
      label_setting &&
      zoom >= label_setting.max_zoom_level &&
      !isLabelFeature
    ) {
      // 커스텀 라벨

      // 수정된 데이터 체크
      if (
        feature.values_.edited_property &&
        feature.values_.edited_property[label_setting.key]
      ) {
        text = feature.values_.edited_property[label_setting.key];
      } else {
        text = feature.values_[label_setting.key];
      }

      if (label_setting.key2) {
        text = setCustomText(text, label_setting.key);
        if (
          feature.values_.edited_property &&
          feature.values_.edited_property[label_setting.key2]
        ) {
          text += ` ${feature.values_.edited_property[label_setting.key2]}`;
        } else {
          text += ` ${feature.values_[label_setting.key2]}`;
        }
      }

      // 도로/철도/BRT
      if (isRoadRailBrt && style.stroke) {
        let type = "ROAD_RAIL_BRT_TEXT";
        if (
          feature.values_.edited_property &&
          feature.values_.edited_property.legend
        ) {
          legend = feature.values_.edited_property.legend;
        } else {
          legend = feature.values_.legend;
        }

        if (["IC", "JC", "역"].includes(legend)) {
          // IC, JC 는 텍스트가 아이콘을 가리기에 Offset을 줌.
          offsetY = zoom * 2;
          type = "IC_JC_STATION_TEXT";
        }

        if (
          feature.values_.edited_property &&
          feature.values_.edited_property.business_class
        ) {
          business_class = feature.values_.edited_property.business_class;
        } else {
          business_class = feature.values_.business_class;
        }

        // 확장인 경우 text에 (확장) 추가
        if (business_class == "확장") {
          text = "(확장) " + text;
        }

        if (
          feature.values_.edited_property &&
          feature.values_.edited_property.stru
        ) {
          stru = feature.values_.edited_property.stru;
        } else {
          stru = feature.values_.stru;
        }

        // 복선인 경우 (복선화) 추가
        if (["복선", "2복선", "3복선"].includes(stru)) {
          text = "(복선화) " + text;
        }

        font = getTextByZoom(zoom, type);

        if (!font) return null;
        const strokeWidth = 5 * scale;
        font = scaledFont(font, scale);
        font = "normal " + font.replace(" Roboto", "/1 Arial");
        return new Text({
          font: font,
          text: linebreakText(text),
          overflow: true,
          fill: new Fill({ color: style.stroke.color }),
          stroke: new Stroke({ color: [255, 255, 255], width: strokeWidth }),
          // maxAngle: 45,
          scale: 1 / scale,
          align: "center",
          offsetX: 0,
          rotation: 0,
          offsetY: offsetY,
        });
      }
    } else if (style.text) {
      // label 타입
      let text = style.text;

      font = getTextByZoom(zoom, "NORMAL_TEXT");
      if (!text || !font) return null;

      const strokeWidth = text.stroke.width * scale;
      font = scaledFont(font, scale);
      font = "normal " + font.replace(" Roboto", "/1 Arial");
      return new Text({
        font: font,
        text: linebreakText(getLabelName(feature, zoom)),
        overflow: true,
        fill: new Fill(text.fill),
        stroke: new Stroke({ color: text.stroke.color, width: strokeWidth }),
        backgroundFill: new Fill(text.backgroundFill),
        backgroundStroke: new Stroke(text.backgroundStroke),
        padding: text.padding,
        textAlign: "center",
        scale: 1 / scale,
      });
    }

    font = getTextByZoom(zoom, "NORMAL_TEXT");
    if (!text || !font) return null;

    let devFontSize = store.getters.getDev?.font || 0;
    let devStrokeSize = store.getters.getDev?.stroke || 0;

    const strokeWidth = (3 + devStrokeSize) * scale;
    font = scaledFont(getTextByZoom(zoom, "NORMAL_TEXT", devFontSize), scale);
    font = "normal " + font.replace(" Roboto", "/1 Arial");
    return new Text({
      font: font,
      text: linebreakText(text),
      overflow: true,
      fill: new Fill({
        color: "#000",
      }),
      stroke: new Stroke({
        color: "#fff",
        width: strokeWidth,
      }),
      scale: 1 / scale,
    });
  },
  setDefault(type = "") {
    if (type == "image") {
      return {
        fill: new Fill({ color: [255, 255, 255, 0.000001] }),
        stroke: new Stroke({
          color: [57, 156, 205, 0.1],
        }),
      };
    }
    return {
      fill: new Fill({ color: [255, 255, 255, 0.2] }),
      stroke: new Stroke({
        color: [57, 156, 205],
      }),
    };
  },
  // Utils
  getLegend(feature, legend_key = null) {
    /*
      Comment:
        multi legend 인 경우 legend 명칭을 추출함.
    */

    let legend = "";

    if (
      feature.values_.edited_property &&
      feature.values_.edited_property.legend
    ) {
      legend = feature.values_.edited_property.legend;
    } else {
      if (
        legend_key &&
        feature.values_.edited_property &&
        feature.values_.edited_property[legend_key]
      ) {
        legend = feature.values_.edited_property[legend_key];
      } else {
        legend = feature.values_.legend; // 내부 서버에서 담는 위치
      }
    }

    if (!legend && legend_key) {
      if (
        feature.values_.edited_property &&
        feature.values_.edited_property[legend_key]
      ) {
        legend = feature.values_.edited_property[legend_key];
      } else {
        legend = feature.values_[legend_key];
      }
    }
    if (!legend) {
      if (
        feature.values_.edited_property &&
        feature.values_.edited_property.lcl_nam
      ) {
        legend = feature.values_.edited_property.lcl_nam;
      } else {
        legend = feature.values_.lcl_nam;
      }
    }
    // vworld
    if (!legend) {
      if (
        feature.values_.edited_property &&
        feature.values_.edited_property.legend
      ) {
        legend = feature.values_.edited_property.legend;
      } else {
        legend = feature.values_.legend;
      }
    }
    // vworld
    if (!legend) {
      if (
        feature.values_.edited_property &&
        feature.values_.edited_property.AGRDE_5_CLASS_SE_CODE
      ) {
        legend = feature.values_.edited_property.AGRDE_5_CLASS_SE_CODE;
      } else {
        legend = feature.values_.AGRDE_5_CLASS_SE_CODE;
      }
    }
    // 건축물 연령정보
    if (!legend) {
      if (
        feature.values_.edited_property &&
        feature.values_.edited_property.MAIN_PRPOS_CODE_NM
      ) {
        legend = feature.values_.edited_property.MAIN_PRPOS_CODE_NM;
      } else {
        legend = feature.values_.MAIN_PRPOS_CODE_NM;
      }
    }

    return legend;
  },
  getKey(feature) {
    /*
      Comment:
        typename 이 Caching key 가 되며, 다수의 legend 가 지정된 경우 'key_legend'
        로 구성.
      Example:
        feature.id_ 는 'lt_p_bycracks.7796' 처럼 typename.featureId 로
        구성되었기에 split으로 featureId 제거
    */
    let key = feature.id_.split(".")[0];
    let lenged = this.getLegend(feature);

    let customKey = "";

    if (
      feature.values_.edited_property &&
      feature.values_.edited_property.rdln
    ) {
      customKey = feature.values_.edited_property.rdln;
    } else {
      customKey = feature.values_.rdln;
    }

    if (customKey) return `${key}_${lenged}-${customKey}`;
    if (lenged) return `${key}_${lenged}`;
    else return key;
  },
};

const CUSTOM_SIZE = {
  IC_JC_STATION_ICON: {
    14: 18 / 128,
    13: 18 / 128,
    12: 18 / 128,
    11: 18 / 128,
    10: 18 / 128,
    9: 16 / 128,
    8: 14 / 128,
    7: 10 / 128,
    6: 8 / 128,
  },
  IC_JC_STATION_TEXT: {
    14: 13,
    13: 13,
    12: 13,
    11: 13,
    10: 13,
    9: 12,
  },
  NORMAL_TEXT: {
    14: 12,
    13: 12,
    12: 12,
    11: 12,
    10: 12,
    9: 11,
    8: 10,
  },
  ROAD_RAIL_BRT_TEXT: {
    14: 14,
    13: 14,
    12: 14,
    11: 14,
    10: 14,
    9: 13,
    8: 11,
  },
};

function createLabelImage(textStyle) {
  const font = textStyle.font_ || "12px Roboto";
  const stroke = textStyle.stroke_ || { color_: [0, 0, 0] };
  if (!stroke.color_) stroke.color_ = [0, 0, 0];

  const fill = textStyle.fill_ || { color_: [255, 255, 255] };
  if (!fill.color_) fill.color_ = [255, 255, 255];

  const text = textStyle.text_ || null;

  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");

  // 해상도 배율
  const scale = 2;

  // 기본 색상 설정
  let strokeColor = "rgb(0,0,0)";

  if (stroke.color_.includes("#")) {
    strokeColor = stroke.color_;
  } else {
    strokeColor = `rgb(${stroke.color_.join(",")})`;
  }

  let fillColor = "rgb(255,255,255)";
  if (fill.color_.includes("#")) {
    fillColor = fill.color_;
  } else {
    fillColor = `rgb(${fill.color_.join(",")})`;
  }

  // 폰트 설정
  ctx.font = font;

  // 텍스트 크기 계산
  const metrics = ctx.measureText(text);
  const textWidth = Math.ceil(metrics.width);
  const textHeight = Math.ceil(
    metrics.actualBoundingBoxAscent + metrics.actualBoundingBoxDescent
  );

  const padding = 2; // 여백
  const width = textWidth + padding * 2;
  const height = textHeight + padding * 2;

  // 캔버스 크기 설정 (해상도 배율 적용)
  canvas.width = width * scale;
  canvas.height = height * scale;

  // 해상도에 맞게 축소
  ctx.scale(scale, scale);

  // 배경 투명 처리
  ctx.clearRect(0, 0, width, height);

  // 중앙 정렬 설정
  ctx.textAlign = "center";
  ctx.textBaseline = "middle";

  // 외곽선 텍스트
  ctx.strokeStyle = strokeColor;
  ctx.lineWidth = (stroke.width_ / scale) * 1.5; // 선 두께를 축소하여 동일하게 보이도록
  ctx.strokeText(text, width / 2, height / 2);

  // 내부 텍스트
  ctx.fillStyle = fillColor;
  ctx.fillText(text, width / 2, height / 2);

  // 데이터 URL 반환
  return canvas.toDataURL();
}

export function textToImageStyles(styles, zoom, feature) {
  if (zoom || feature) return styles;
  const id = feature.id_.split(".")[0];
  const useImageIds = {
    "7f2c770b-2e02-4ce3-872e-70ca6faaa539": "ROAD_RAIL_BRT_TEXT",
    "8ca73eb1-a282-42a8-8fcb-7569239562a6": "ROAD_RAIL_BRT_TEXT",
  };

  if (!useImageIds[id]) return styles;

  const textType = useImageIds[id];
  const newStyles = [];

  styles.forEach((style) => {
    if (
      !style.text_ ||
      !style.text_.text_ ||
      style.image_ ||
      style.geometry_ ||
      !style.getText()
    ) {
      newStyles.push(style);
      return;
    }

    const scale = getScaleByZoom(zoom, textType);
    const image = new Icon({
      src: createLabelImage(style.getText()),
      anchor: [0.5, 0.5],
      scale: scale / 20,
    });

    const extraImageStyle = new Style({
      image: image,
    });

    const center = calculateGeometryCenter(feature);
    const point = new Point(center);
    extraImageStyle.setGeometry(point);
    extraImageStyle.setZIndex(style.zIndex + 1);
    newStyles.push(extraImageStyle);
    // style.setText(null);
    // console.log(feature)
    newStyles.push(style);
  });

  return newStyles;
}
function calculateGeometryCenter(feature) {
  const geometry = feature.getGeometry();
  const type = geometry.getType();
  const coordinates = geometry.getCoordinates();

  switch (type) {
    case "Point":
      return coordinates;

    case "MultiPoint": {
      // 여러 포인트의 평균 좌표 계산
      const xSum = coordinates.reduce((sum, coord) => sum + coord[0], 0);
      const ySum = coordinates.reduce((sum, coord) => sum + coord[1], 0);
      return [xSum / coordinates.length, ySum / coordinates.length];
    }

    case "LineString": {
      // 라인 스트링의 중간 좌표 계산
      const midIndex = Math.floor(coordinates.length / 2);
      return coordinates[midIndex];
    }

    case "MultiLineString": {
      // 여러 라인 스트링의 평균 좌표 계산
      const flatCoords = coordinates.flat();
      const midIndex = Math.floor(flatCoords.length / 2);
      return flatCoords[midIndex];
    }

    case "Polygon": {
      // 폴리곤의 경계 중심 계산
      const extent = geometry.getExtent();
      const center = getExtentCenter(extent);

      // 중심에 가장 가까운 점 찾기
      const coordinatesFlat = geometry.getCoordinates().flat();
      const closest = coordinatesFlat.reduce((prev, curr) => {
        const prevDist = Math.hypot(center[0] - prev[0], center[1] - prev[1]);
        const currDist = Math.hypot(center[0] - curr[0], center[1] - curr[1]);
        return currDist < prevDist ? curr : prev;
      });

      return closest;
    }

    case "MultiPolygon": {
      // 멀티 폴리곤의 경계 중심 계산
      const extent = geometry.getExtent();
      const center = getExtentCenter(extent);

      // 중심에 가장 가까운 점 찾기
      const coordinatesFlat = geometry.getCoordinates().flat(2);
      const closest = coordinatesFlat.reduce((prev, curr) => {
        const prevDist = Math.hypot(center[0] - prev[0], center[1] - prev[1]);
        const currDist = Math.hypot(center[0] - curr[0], center[1] - curr[1]);
        return currDist < prevDist ? curr : prev;
      });

      return closest;
    }

    case "Circle":
      // 서클의 중심 좌표 반환
      return geometry.getCenter();

    default:
      // console.warn(`지원하지 않는 타입: ${type}`);
      return [0, 0];
  }
}
